import Modal from 'utils/packages/Modal';
const AutosaveRulesWarningModal = {
    show: (handlePauseAutosave, handleCancel) => {
        Modal.showConfirmation({
            title: 'Hold on 💫',
            subtitle: 'For autosave to work you need at least one active rule, you can’t deactivate them all. If you are looking to stop the autosaves, you can temporarily pause it.',
            confirmButtonTitle: 'Pause autosave',
            cancelButtonTitle: 'Close',
            onConfirm: handlePauseAutosave,
            onPressCancel: handleCancel,
            onBackdropPress: handleCancel,
            onSwipeComplete: handleCancel,
            onAndroidBackButtonPress: handleCancel,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
export default AutosaveRulesWarningModal;
